export default __webpack_public_path__ + "static/media/tutorial-08.964431ff.jpg";